import { Navigate, Route, Routes } from 'react-router-dom';

import AsistenteDelAnio from './pantallas/AsistenteDelAnio.jsx';
import RegistroDePresupuesto from './pantallas/RegistroDePresupuesto.jsx';
import TableroDePresupuesto from './pantallas/TableroDePresupuesto.jsx';

/**
 * Destino "Presupuesto" del incremento 5/6 (RF-108, D-07).
 *
 * El módulo resuelve sus propias rutas internas y NO reclama lugar nuevo en la
 * barra: usa la sección `presupuesto` que el núcleo ya registra, igual que hizo el
 * 3/6. El sexto lugar sigue siendo de Ajustes (RN-044b).
 *
 * TRES PANTALLAS, LAS DEL PROTOTIPO v20:
 *   · `/presupuesto`                    tablero de monitoreo del mes (RF-101 a RF-105).
 *   · `/presupuesto/registro/:idPeriodo` registro del presupuesto de un mes (RF-097 a RF-099).
 *   · `/presupuesto/anio/:anio`          asistente «Definir el presupuesto de AAAA» (RF-110).
 *
 * El asistente es UNA PANTALLA A LA QUE SE ENTRA A PROPÓSITO, nunca un diálogo que
 * salte solo: nada se genera al abrir la aplicación ni al cambiar de mes (RN-223c).
 */
export default function Presupuesto() {
  return (
    <Routes>
      <Route index element={<TableroDePresupuesto />} />
      <Route path="registro" element={<RegistroDePresupuesto />} />
      <Route path="registro/:idPeriodo" element={<RegistroDePresupuesto />} />
      <Route path="anio/:anio" element={<AsistenteDelAnio />} />
      <Route path="*" element={<Navigate to="/presupuesto" replace />} />
    </Routes>
  );
}
